// 用户

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
    myPurchasedCourse: null,
    myPublishedCourse: null
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
